/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseGroupRequest } from './BaseGroupRequest';
import {
    BaseGroupRequestFromJSON,
    BaseGroupRequestFromJSONTyped,
    BaseGroupRequestToJSON,
} from './BaseGroupRequest';
import type { PartialGroup } from './PartialGroup';
import {
    PartialGroupFromJSON,
    PartialGroupFromJSONTyped,
    PartialGroupToJSON,
} from './PartialGroup';
import type { PropertyUpdate } from './PropertyUpdate';
import {
    PropertyUpdateFromJSON,
    PropertyUpdateFromJSONTyped,
    PropertyUpdateToJSON,
} from './PropertyUpdate';
import type { RedAppPlacementSetting } from './RedAppPlacementSetting';
import {
    RedAppPlacementSettingFromJSON,
    RedAppPlacementSettingFromJSONTyped,
    RedAppPlacementSettingToJSON,
} from './RedAppPlacementSetting';
import type { WorkflowEnablement } from './WorkflowEnablement';
import {
    WorkflowEnablementFromJSON,
    WorkflowEnablementFromJSONTyped,
    WorkflowEnablementToJSON,
} from './WorkflowEnablement';
import type { WorkspaceEnablement } from './WorkspaceEnablement';
import {
    WorkspaceEnablementFromJSON,
    WorkspaceEnablementFromJSONTyped,
    WorkspaceEnablementToJSON,
} from './WorkspaceEnablement';

/**
 * 
 * @export
 * @interface UpdateGroupRequest
 */
export interface UpdateGroupRequest extends BaseGroupRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateGroupRequest
     */
    addedCmGroupIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateGroupRequest
     */
    removedCmGroupIds?: Array<number>;
}

/**
 * Check if a given object implements the UpdateGroupRequest interface.
 */
export function instanceOfUpdateGroupRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateGroupRequestFromJSON(json: any): UpdateGroupRequest {
    return UpdateGroupRequestFromJSONTyped(json, false);
}

export function UpdateGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...BaseGroupRequestFromJSONTyped(json, ignoreDiscriminator),
        'addedCmGroupIds': !exists(json, 'addedCmGroupIds') ? undefined : json['addedCmGroupIds'],
        'removedCmGroupIds': !exists(json, 'removedCmGroupIds') ? undefined : json['removedCmGroupIds'],
    };
}

export function UpdateGroupRequestToJSON(value?: UpdateGroupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...BaseGroupRequestToJSON(value),
        'addedCmGroupIds': value.addedCmGroupIds,
        'removedCmGroupIds': value.removedCmGroupIds,
    };
}

